import _ from "lodash";
import React, { useContext, useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import UserService from "../../Services/UserService";
import {
  EMPTY_GUID,
  ORDER,
  ROOT_PATH,
  formActionEnum,
  jsonKeyMapping,
  templateActionEnum,
  LETTER_SIZE,
  colors,
} from "../../Config/Constants";
import TemplateDataContext from "../../Contexts/TemplateData.context";
import useLoadJson from "../../Hooks/LoadJson";
import useNavigateRoutes from "../../Hooks/NavigateRoutes";
import { logger } from "../../Middleware/Logger";
import ModalComponent from "../Shared/ModalComponent";
import SaveDocumentModal from "../Shared/SaveDocumentModal/SaveDocumentModal";
import FormPreview from "./TemplateDesign/FormPreview";
import MainForm from "./TemplateDesign/MainForm";
import SideNavbar from "./TemplateDesign/SideNavbar";
import FormDataContext from "../../Contexts/FormData.context";
import {
  createDoc,
  createParagraphService,
  getPdfSimpliDoc,
  updateParagraphService,
} from "../../Services/TemplateServices";
import {
  createCookie,
  createParagraph,
  emptyDocument,
  filterParagraph,
  getDocIds,
  readCookie,
  saveDocIds,
  PerquisiteBountyEnable,
  redirectToPMSAndExistPlanPage,
} from "../../Util/helper";
import { v4 as UUID4 } from "uuid";
import { TemplateObject } from "../../Models/TemplateObject";
import axios from "axios";
import ErrorMessage from "../../Util/ErrorMessage";
import { APP_NAVIGATION, ROUTE_CONSTANT } from "../../Util/Constants";
import PathHelper from "../../Util/PathHelper";
import UserDataContext from "../../Contexts/User.context";
import { appDomain } from "../../Util/general-config";
import UserServiceApi from "../../Services/UserService";
import DocBuilderService from "../../Services/DocBuilderService";
import ReactLoader from "../../Components/Shared/Loader/Loader";
import { UploadHtmlToBlob, navigateToSignleLoginAPP } from "../../Util/helper";

const SetTemplateDesign = () => {
  const {
    state: { userGUID, email },
  } = useContext(UserDataContext);

  //const { userData } = useContext(UserDataContext);
  let { templateType, template, stepName, state } = useParams();
  const navigate = useNavigate();
  const [showLoader, setShowLoader] = useState("d-none");

  const formData = useContext(FormDataContext);
  const docId: string = formData.state?.docId as string;
  const paragraph = formData.state?.paragraph;
  const formValue: object = formData.state?.formData;
  const visitorGuid: string = readCookie("visitorGuid") as string;
  const templateID: string = templateType as string;
  const templateNum: string = template as string;
  const templateNumber: string = templateNum.substr(templateNum.length - 1);

  stepName = stepName?.toLowerCase();
  const { state: templateState, dispatch } = useContext(TemplateDataContext);
  const {
    templates,
    showTemplateModal,
    showSaveDocumentModal,
    activeTemplateSteps,
  } = templateState;
  const [stepDetails, setStepDetails] = useState({});
  const [isHideSteps, setIsHideSteps] = useState<string[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [filterFormValue, setFilterFormValue] = useState({});
  const { state: formState } = useContext(FormDataContext);
  const { activeColor, docStyle } = formState;
  const RedirectPath = PathHelper(APP_NAVIGATION.TEMP);
  const [isGuestUser, setisGuestUser] = useState<boolean>(false);
  const templatePrev = useRef<HTMLDivElement>(null);
  const stepLength: any = stepDetails;
  const activeStepLength =
    Object.keys(stepLength).length > 0 &&
    stepLength.formGroup &&
    Array.isArray(stepLength.formGroup)
      ? stepLength.formGroup.length
      : 0;
  let currentStepNumber = activeTemplateSteps.findIndex(
    (x) => x[jsonKeyMapping.SLUGIFY] === stepName
  );
  if (activeTemplateSteps.length > 0) {
    stepName =
      currentStepNumber === -1 ? activeTemplateSteps[0].slugify : stepName;
  }
  const frstStep =
    Object.keys(stepLength).length > 0 &&
    stepLength.formGroup &&
    Object.keys(stepLength.formGroup).length === 0
      ? stepLength.stepname.toLowerCase()
      : "";
  useEffect(() => {
    const hideSteps: string[] = [];

    activeTemplateSteps.length > 0 &&
      activeTemplateSteps.forEach((item: any) => {
        if (item.formGroup && item.formGroup.length === 0) {
          hideSteps.push(item.slugify);
        }
      });
    setIsHideSteps(hideSteps);
  }, [templateState]);

  useEffect(() => {
    const filterFormKey: object = { ...formValue };

    // remove meta-data keys
    for (const key in filterFormKey) {
      if (key.includes("meta-data-")) {
        delete filterFormKey[key as keyof object];
      }
    }

    setFilterFormValue(filterFormKey);
  }, [formValue]);

  useEffect(() => {
    if (state)
      dispatch({ type: templateActionEnum.SET_SELECTED_STATE, payload: state });
    return () => {};
  }, [state]);

  if (state) {
    /* Load Json */
    useLoadJson({
      endPoint: `state-specific/${templateType}`,
      jsonFileName: `${_.capitalize(state)}.json`,
      state: _.capitalize(state),
    });

    // all the sub routes will change from this
    useNavigateRoutes({
      templates,
      setStepDetails,
      state,
    });
  } else {
    /* Load Json */
    useLoadJson({
      endPoint: templateType || "",
      jsonFileName: `${templateType}.json`,
    });

    // all the sub routes will change from this
    useNavigateRoutes({
      templates,
      setStepDetails,
    });
  }

  useEffect(() => {
    setShowLoader("d-none");
    handleDocId();
    if (!!readCookie("jwtToken")) {
      UserService.getUserObject().then((response: any) => {
        let isGuestUser = false;
        if (response) {
          isGuestUser = response.parentUserGuid ? true : false;
        }
        setisGuestUser(isGuestUser);
      });
    }

    const visitorId = UUID4();
    if (visitorGuid === null || visitorGuid === "") {
      createCookie("visitorGuid", visitorId, 1);
    }
  }, []);

  // When the `template` route param changes we must reset form & step related state
  // to avoid showing data from a previously-opened template until the new
  // template JSON has been loaded. This mirrors the behavior in LoadTemplate
  // which resets form state when `templateType` changes.
  // Reset form & template-specific transient state whenever the template slug changes.
  // This ensures pasting a new URL (different template) does not show previous form values.
  useEffect(() => {
    try {
      formData.dispatch({ type: formActionEnum.RESET_FORM_DATA });
      formData.dispatch({ type: formActionEnum.RESET_STEP_DATA });
      formData.dispatch({ type: formActionEnum.SET_COLOR, payload: activeColor || colors[9] });
      formData.dispatch({ type: formActionEnum.SET_DOC_ID, payload: "" });
      formData.dispatch({ type: formActionEnum.SET_PARAGRAPH, payload: {} });
      formData.dispatch({ type: formActionEnum.RESET_BLANK_FORM_DATA });
      dispatch({ type: templateActionEnum.SET_STEP_FLAG, payload: false });
      dispatch({ type: templateActionEnum.SET_NAVBAR_STATE, payload: false });
      setStepDetails({});
    } catch (err) {
      console.error("Error resetting state on template change", err);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [template]);

  // If user pastes a URL where the stepName doesn't belong to the currently loaded template's steps
  // (common when switching templates directly via address bar), force navigation to the first step
  // after templates have been loaded. This prevents showing stale fields until manual interaction.
  useEffect(() => {
    if (!template || !stepName) return; // need both slugs
    if (activeTemplateSteps.length === 0) return; // steps not yet populated

    const belongsToTemplate = activeTemplateSteps.some(
      (s: any) => s[jsonKeyMapping.SLUGIFY] === stepName
    );
    if (!belongsToTemplate) {
      // Navigate to first valid step for this template
      const first = activeTemplateSteps[0];
      if (first && first[jsonKeyMapping.SLUGIFY]) {
        if (state) {
          navigate(
            `/${ROOT_PATH}/state-specific/${templateType}/${state}/${template}/${first[jsonKeyMapping.SLUGIFY]}`,
            { replace: true }
          );
        } else {
          navigate(
            `/${ROOT_PATH}/${templateType}/${template}/${first[jsonKeyMapping.SLUGIFY]}`,
            { replace: true }
          );
        }
      }
    }
  }, [activeTemplateSteps, stepName, template, templateType, state, navigate]);

  // handleDocId function is find the template docId and update the form value
  const handleDocId = async () => {
    let docId: string = "";
    const queryParams = new URLSearchParams(window.location.search);
    docId = queryParams.get("docid") || "";
    if (docId == "") {
      const getDocId = await getDocIds();
      if (getDocId) {
        //let docId = ''
        for (const key in getDocId) {
          if (key.includes(templateID)) {
            docId = getDocId[templateID];
          }
        }
      }
    }
    //let skuId = queryParams.get("s")
    // const getDocId = await getDocIds()
    // if (getDocId) {
    //     //let docId = ''
    //     for (const key in getDocId) {
    //         if (key.includes(templateID)) {
    //             docId = getDocId[templateID]
    //         }
    //     }

    if (docId !== "") {
      const getDocuments = await getPdfSimpliDoc(docId);
      if (getDocuments.data.paragraphs.length > 0) {
        const paragraph = getDocuments.data.paragraphs;
        const para = filterParagraph(paragraph);
        const storeParaResponse = {
          paraId: para.paraId,
          paraContentId: para.paraId,
        };

        formData.dispatch({ type: formActionEnum.SET_DOC_ID, payload: docId });
        formData.dispatch({
          type: formActionEnum.SET_PARAGRAPH,
          payload: storeParaResponse,
        });
        if (Object.keys(para.content).length > 0) {
          const paraKeys: any = para.content;
          formData.dispatch({
            type: formActionEnum.SET_FORM_DATA,
            payload: paraKeys,
          });
        }
      }
    }
    //}
  };
const createDocId = async () => {
  if (template !== undefined) {
    const existingStepIndex = _.findIndex(activeTemplateSteps, {
      [jsonKeyMapping.SLUGIFY]: stepName,
    });
    if (existingStepIndex > -1 && activeTemplateSteps.length > existingStepIndex) {
      let userid: any = !!userGUID ? userGUID : !!readCookie("userguid") ? readCookie("userguid") : EMPTY_GUID;
      const data = emptyDocument(
        visitorGuid,
        templateID,
        templateNumber,
        template,
        activeTemplateSteps[existingStepIndex][jsonKeyMapping.SLUGIFY],
        activeColor.colorHashValue,
        userid,
        String(docStyle.letterSize),
        state
      );
      const tempFormData: TemplateObject = { ...formValue };
      let modiefiedVal = updateAddMoreFormFields(tempFormData, filterFormValue);
      // create document ID
      const docResponse = await createDoc(data);
      const para = createParagraph(
        EMPTY_GUID,
        docResponse.data.docGuid,
        JSON.stringify(modiefiedVal),
        ORDER,
        templateID,
        EMPTY_GUID
      );
      if (docResponse && docResponse.data) {
        createCookie("docid", docResponse.data.docGuid, 1);
      }
      // create paragraph
      const paraResponse = await createParagraphService(docResponse.data.docGuid, para);
      const storeParaResponse = {
        paraId: paraResponse.data.id,
        paraContentId: paraResponse.data.paraContents[0].id,
      };

      // store and navigate
      formData.dispatch({
        type: formActionEnum.SET_DOC_ID,
        payload: docResponse.data.docGuid,
      });
      formData.dispatch({
        type: formActionEnum.SET_PARAGRAPH,
        payload: storeParaResponse,
      });
      let templateIdToSave = templateID;
      if (state) {
        templateIdToSave = "state-specific/" + templateID;
      }
      saveDocIds(templateIdToSave, docResponse.data.docGuid);
    }
  }
};
  const nextBtnHandler = async () => {
    try {
      if (template !== undefined) {
        const existingStepIndex = _.findIndex(activeTemplateSteps, {
          [jsonKeyMapping.SLUGIFY]: stepName,
        });
        if (
          existingStepIndex > -1 &&
          activeTemplateSteps.length > existingStepIndex
        ) {
          setIsLoading(true);
          const nextSlugify =
            activeTemplateSteps[existingStepIndex + 1][jsonKeyMapping.SLUGIFY];
          if (docId === "") {
            await createDocId();
            setIsLoading(false);
            if (state) {
              navigate(
                `/${ROOT_PATH}/state-specific/${templateType}/${state}/${template}/${nextSlugify}`
              );
            } else {
              navigate(
                `/${ROOT_PATH}/${templateType}/${template}/${nextSlugify}`
              );
            }
          } else {
            const tempFormData: TemplateObject = { ...formValue };
            let modiefiedVal = updateAddMoreFormFields(
              tempFormData,
              filterFormValue
            );
            const updatePara = createParagraph(
              paragraph.paraId,
              docId,
              JSON.stringify(modiefiedVal),
              ORDER,
              templateID,
              paragraph.paraContentId
            );
            await updateParagraphService(docId, paragraph.paraId, updatePara);
            //Save HTML to blob for each next button click for auth Users
            let userid: any = !!userGUID ? userGUID : !!readCookie("userguid") ? readCookie("userguid") : "";
            if (!!userid) {
              let htmlContent = templatePrev?.current?.innerHTML;
               htmlContent = `
                <style>
                  .thumb-preview-wrap {
                    padding: 2em;
                  }
                </style>
                ${htmlContent}`;
              const userGuid = userid || "a000000000000000000000000000000a";
             await UploadHtmlToBlob(userGuid, docId, htmlContent, templateID);
            }
            //End
            setIsLoading(false);
            if (state) {
              navigate(
                `/${ROOT_PATH}/state-specific/${templateType}/${state}/${template}/${nextSlugify}`
              );
            } else {
              navigate(
                `/${ROOT_PATH}/${templateType}/${template}/${nextSlugify}`
              );
            }
          }
        }
      }

      // setStepsCompleted([...stepsCompleted, stepNumber])
    } catch (error) {
      logger.error(
        "🚀 ~ file: SetTemplate.tsx ~ line 37 ~ nextBtnHandler ~ error",
        error
      );
    }
  };
  const updateAddMoreFormFields = (tempFormData: any, filterFormValue: any) => {
    let modifiedFormValue = { ...filterFormValue };
    for (const formKey in tempFormData) {
      const getElements = Array.from(document.getElementsByClassName(formKey));
      getElements.map((element) => {
        const metaKeyName = `meta-data-${formKey}`;
        /* ADD MORE Input Text with separator */
        if (
          tempFormData[metaKeyName] !== undefined &&
          tempFormData[metaKeyName].addMoreElement === true &&
          tempFormData[metaKeyName].separator !== null
        ) {
          const id = tempFormData[metaKeyName].separatorId;
          let values: any = [];
          if (!tempFormData[metaKeyName].isGroupAdd) {
            const inputFields = Object.keys(formValue).filter((key) => {
              const re = new RegExp(`^${id}\\d$`, "g");
              return key.match(re);
            });
            inputFields.forEach((inputId) => {
              if (tempFormData[inputId]) {
                values.push(tempFormData[inputId]);
              }
            });

            let modifiedValues = values;
            if (
              tempFormData[metaKeyName].startsWith !== "" &&
              values.length > 0
            ) {
              modifiedValues = [];
              values.forEach((val: string) => {
                let modiedfield =
                  tempFormData[metaKeyName].startsWith +
                  val +
                  tempFormData[metaKeyName].endsWith;
                modifiedValues.push(modiedfield);
              });
            }
            if (tempFormData[id]) {
              // values.unshift(tempFormData[id]);
              let frstUpShiftVal =
                tempFormData[metaKeyName].endsWith !== ""
                  ? tempFormData[id] + tempFormData[metaKeyName].endsWith
                  : tempFormData[id];
              modifiedValues.unshift(frstUpShiftVal);
            }

            const formElementData: TemplateObject = {
              [id + "FormFields"]: modifiedValues.join(
                tempFormData[metaKeyName].separator
              ),
            };
            modifiedFormValue = { ...modifiedFormValue, ...formElementData };
            formData.dispatch({
              type: formActionEnum.SET_FORM_DATA,
              payload: formElementData,
            });
          }
          let moregrpInputs: any = "";
          let firstGrpValues: any = [];
          if (tempFormData[metaKeyName].isGroupAdd === true) {
            const dynamicIndex = tempFormData[metaKeyName].dynamicIndex;
            const children = tempFormData[metaKeyName].children;
            const groupSeparator =
              tempFormData[metaKeyName].groupInputSeparator;
            const groupInputFormate =
              tempFormData[metaKeyName].groupInputFormate;
            const signatureFields = tempFormData[metaKeyName].signatureFields;
            if (dynamicIndex) {
              dynamicIndex.forEach((inputIndex: number) => {
                const valueMap: string[] = [];
                let childrensCls: any = [];
                children.forEach((inputId: string) => {
                  childrensCls.push(`${inputId}-${inputIndex}`);
                  if (tempFormData[`${inputId}-${inputIndex}`]) {
                    valueMap.push(tempFormData[`${inputId}-${inputIndex}`]);
                  }
                });
                if (valueMap.length > 0) {
                  if (groupInputFormate === "table") {
                    let moreCol: any = "";

                    let hasfields: any = [];
                    if (
                      !!element.getAttribute("data-signatureFields") &&
                      signatureFields !== " "
                    ) {
                      let inputSignVal: any = "";
                      childrensCls.forEach((inputId: string, index: number) => {
                        let val = !!tempFormData[`${inputId}`]
                          ? tempFormData[`${inputId}`]
                          : "";
                        signatureFields.forEach((signObj: any) => {
                          if (signObj.id === inputId.split("-")[0]) {
                            inputSignVal +=
                              '<div class="col-md-6"><span style="min-height: 1.5em;border-bottom:1px solid #000;display:block; padding-bottom: 0px;" class="' +
                              inputId +
                              '" data-signatureFields="yes">' +
                              val +
                              '</span><p style="margin-bottom: 10px;"> ' +
                              signObj.label +
                              "</p></div>";
                          } else {
                            if (hasfields.indexOf(signObj.id) >= 0) {
                            } else {
                              moreCol +=
                                '<div class="col-md-6"><span style="min-height: 1.5em;border-bottom:1px solid #000;display:block;" class="' +
                                signObj.id +
                                '"></span><p style="margin-bottom: 10px;"> ' +
                                signObj.label +
                                "</p></div>";
                            }
                          }
                          hasfields.push(signObj.id);
                        });
                      });
                      let tableRow =
                        '<div class="row" style="margin-bottom: 15px;">' +
                        moreCol +
                        inputSignVal +
                        "</div>";
                      values.push(tableRow);
                      moregrpInputs += tableRow;
                    } else {
                      childrensCls.forEach((inputId: string, index: number) => {
                        let val = !!tempFormData[`${inputId}`]
                          ? tempFormData[`${inputId}`]
                          : "";
                        moreCol +=
                          '<td><span class="' +
                          inputId +
                          '">' +
                          val +
                          "</span></td>";
                      });
                      let tableRow =
                        '<tr class="table-row">' + moreCol + "</tr>";
                      values.push(tableRow);
                      moregrpInputs += tableRow;
                    }
                  } else {
                    values.push(valueMap.join(groupSeparator));
                  }
                }
              });
            }
            let modifiedValues = values;
            if (
              tempFormData[metaKeyName].startsWith !== "" &&
              values.length > 0
            ) {
              modifiedValues = [];
              values.forEach((val: string) => {
                let modiedfield =
                  tempFormData[metaKeyName].startsWith +
                  val +
                  tempFormData[metaKeyName].endsWith;
                modifiedValues.push(modiedfield);
              });
            }
            if (tempFormData[id]) {
              let frstUpShiftVal =
                tempFormData[metaKeyName].endsWith !== ""
                  ? tempFormData[id] + tempFormData[metaKeyName].endsWith
                  : tempFormData[id];
              modifiedValues.unshift(frstUpShiftVal);
            }
            let modifiedVal = "";
            if (groupInputFormate === "table" && modifiedValues.length > 0) {
              const frstchildren = tempFormData[metaKeyName].children;
              frstchildren.forEach((inputId: string) => {
                firstGrpValues.push(
                  !!tempFormData[`${inputId}`] ? tempFormData[`${inputId}`] : ""
                );
              });
              if (!!element.getAttribute("data-signatureFields")) {
                let combineCol: any = "";
                let inputSignVal: any = "";
                let hasfields: any = [];
                tempFormData[metaKeyName].children.forEach(
                  (inputId: string, index: number) => {
                    signatureFields.forEach((signObj: any) => {
                      console.log(signObj);
                      console.log(inputId);
                      if (signObj.id === inputId.split("-")[0]) {
                        inputSignVal +=
                          '<div class="col-md-6"><span style="min-height: 1.5em;border-bottom:1px solid #000;display:block; padding-bottom: 0px;" class="' +
                          inputId +
                          '" data-signatureFields="yes">' +
                          firstGrpValues[index] +
                          '</span><p style="margin-bottom: 10px;"> ' +
                          signObj.label +
                          "</p></div>";
                      } else {
                        if (hasfields.indexOf(signObj.id) >= 0) {
                        } else {
                          combineCol +=
                            '<div class="col-md-6"><span style="min-height: 1.5em;border-bottom:1px solid #000;display:block;" class="' +
                            signObj.id +
                            '"></span><p style="margin-bottom: 10px;"> ' +
                            signObj.label +
                            "</p></div>";
                        }
                      }
                      hasfields.push(signObj.id);
                    });
                    combineCol +=
                      '<div class="col-md-6" style="display:none"><span class="' +
                      inputId +
                      '" data-signatureFields="yes">' +
                      firstGrpValues[index] +
                      "</span></div>";
                  }
                );
                let firstRow =
                  '<div class="row" style="margin-bottom: 15px;">' +
                  combineCol +
                  inputSignVal +
                  "</div>";
                let finalHtml = firstRow + moregrpInputs;
                modifiedVal = finalHtml;
              } else {
                let combineCol: any = "";
                tempFormData[metaKeyName].children.forEach(
                  (inputId: string, index: number) => {
                    combineCol +=
                      '<td><span class="' +
                      inputId +
                      '">' +
                      firstGrpValues[index] +
                      "</span></td>";
                  }
                );
                let firstRow = '<tr class="table-row">' + combineCol + "</tr>";
                let finalHtml = firstRow + moregrpInputs;
                modifiedVal = finalHtml;
              }
            } else {
              modifiedVal = modifiedValues.join(
                tempFormData[metaKeyName].separator
              );
            }
            let formElementData: TemplateObject = {};
            if (!!element.getAttribute("data-signatureFields")) {
              formElementData = {
                [id + "signfields"]: modifiedVal,
              };
            } else {
              formElementData = {
                [id + "FormFields"]: modifiedVal,
              };
            }
            modifiedFormValue = { ...modifiedFormValue, ...formElementData };
            formData.dispatch({
              type: formActionEnum.SET_FORM_DATA,
              payload: formElementData,
            });
          }
        }
      });
    }
    return modifiedFormValue;
  };
  const backBtnHandler = () => {
    const existingStepIndex = _.findIndex(activeTemplateSteps, {
      [jsonKeyMapping.SLUGIFY]: stepName,
    });
    if (existingStepIndex >= 0) {
      const prevSlugify =
        activeTemplateSteps[existingStepIndex - 1]?.[jsonKeyMapping.SLUGIFY];
      if (prevSlugify) {
        if (state) {
          navigate(
            `/${ROOT_PATH}/state-specific/${templateType}/${state}/${template}/${prevSlugify}`
          );
        } else {
          navigate(`/${ROOT_PATH}/${templateType}/${template}/${prevSlugify}`);
        }
      }
    }
  };
  const formSubmit = async () => {
    setShowLoader("d-block");
    try {
      if (docId !== "") {
        const updatePara = createParagraph(
          paragraph.paraId,
          docId,
          JSON.stringify(filterFormValue),
          ORDER,
          templateID,
          paragraph.paraContentId
        );
        let tempKey: any = template;
        dispatch({
          type: templateActionEnum.SET_ACTIVE_TEMPLATE_HTML,
          payload: tempKey,
        });
        await updateParagraphService(docId, paragraph.paraId, updatePara);
      } else {
          await createDocId();
      }
      //Save HTML to blob for each next button click for unauth/Auth Users
      let userid: any = !!userGUID ? userGUID : !!readCookie("userguid") ? readCookie("userguid") : "";

      let htmlContent = templatePrev?.current?.innerHTML;
          htmlContent = `
          <style>
            .thumb-preview-wrap {
              padding: 2em;
            }
          </style>
          ${htmlContent}`;
      const userGuid = userid || "a000000000000000000000000000000a";
      await UploadHtmlToBlob(userGuid, docId, htmlContent, templateID);
      //End

    // const now = new Date();
    // const yyyy = now.getFullYear();
    // const mm = String(now.getMonth() + 1).padStart(2, "0");
    // const dd = String(now.getDate()).padStart(2, "0");
    // const formattedDate = `_${yyyy}${mm}${dd}`;

    const blobName = `${docId}_${templateID.replaceAll("/", "_")}.html`;
    let queryParam = `?unqn=${blobName}&docid=${docId}&useExternalTemplate=true`;
      // If already logged in redirect to dashboard else signup
      if (!!userid) {
        /**
         * If user is already logged on
         * Check if premium them generate pdf and redirect to dashboard / Home as per env
         * else redirect to plan page
         */
        /////  -------------
        UserServiceApi.getUserProfile(userid).then((userProfileResponse: any) => {
          if (userProfileResponse) {
            console.log(userProfileResponse);
            let isPerquisiteBountyEnable = PerquisiteBountyEnable(
              userProfileResponse.perquisiteBountyKey,
              userProfileResponse.userGuid
            );
            if (isPerquisiteBountyEnable || isGuestUser) {
              if (docId) {
                let useExternalTemplate = true;
                DocBuilderService.GeneratePDFPath(docId, userid, useExternalTemplate).then((docResponse: any) => {
                  console.log(docResponse);
                  if (`${process.env.REACT_APP_ENVIRONMENT}` == "DEVELOPMENT") {
                    navigate(ROUTE_CONSTANT.HOME);
                  } else {
                    window.location.href = appDomain() + ROUTE_CONSTANT.USER_DASHBOARD;
                  }
                });
              }
            } else {
              // let isNavigateToExistingPlanPage = redirectToPMSAndExistPlanPage();
              // if (isNavigateToExistingPlanPage) {
              //   console.log("to Plan page..");
              //   navigate(ROUTE_CONSTANT.PAYMENT_PLAN);
              // }
              window.location.assign("/app/billing/?useExternalTemplate=true");
            }
          } else {
            console.log("signup due to error");
            setShowLoader("d-none");
            navigateToSignleLoginAPP('', true, queryParam);
          }
        });
        //////  --------------
      } else {
        // TO DO ::: Redirect
        setShowLoader("d-none");
        navigateToSignleLoginAPP('', true, queryParam);
      }
      // window.location.href = '/app/template/sign-up';
      // const { data } = await processFormRequest({ formData: submitFormData, config })
      // const { redirectUrl } = data
      // window.location.href = redirectUrl
    } catch (error) {
      setShowLoader("d-none");
      if (!axios.isCancel(error)) {
        logger.error(
          "🚀 ~ file: useEffect.tsx ~ line 47 ~ changeLayout ~ error",
          error
        );
        dispatch({
          type: templateActionEnum.SET_ERROR,
          payload: { show: true, message: ErrorMessage.PROCESSING_FORM },
        });
      }
    }
  };
  const step: string = stepName as string;
const callBackDocIdHandler = () => {
    createDocId();
}
  return (
    <div className="row">
      {/* SIDE NAVBAR */}

      {!isHideSteps.includes(step) && (
        <SideNavbar
          template={template || ""}
          uri={
            state
              ? `/${ROOT_PATH}/state-specific/${templateType}/${state}/${template}`
              : `/${ROOT_PATH}/${templateType}/${template}`
          }
          stepName={stepName || ""}
          isHideSteps={isHideSteps}
        />
      )}
      <section
        className={`${
          activeStepLength && activeStepLength > 0
            ? "sidebar-sticky main-content templates"
            : "active-hwd-section" +
              " step" +
              frstStep +
              " sidebar-sticky main-content templates"
        }${isHideSteps.includes(step) ? " no-sidebar" : ""}`}
      >
        <div className="container">
          <div className="alignment-container">
            <div className="row">
              {/* MAIN FORM */}
              <MainForm
                nextBtn={nextBtnHandler}
                backBtn={backBtnHandler}
                formSubmit={formSubmit}
                stepDetails={stepDetails}
                isHideSteps={isHideSteps}
                isLoading={isLoading}
                templatePrev={templatePrev}
              />
              {/* FORM PREVIEW - Hidden but available for functionality */}
              <FormPreview
                stepDetails={stepDetails}
                template={template || ""}
                templatePrev={templatePrev}
              />
            </div>
          </div>
        </div>
      </section>

      {/* Modal */}
      {/* TODO:CSS : Modal Width--Doing scrollable */}
      {showTemplateModal && <ModalComponent />}
      <SaveDocumentModal callBackDocIdHandler={callBackDocIdHandler} />
      <ReactLoader loaderProps={{ showloader: showLoader }} />
    </div>
  );
};

export default SetTemplateDesign;
